/**
 * Which keys the DB Manager grid may act on (30.09.2026).
 *
 * The grid's shortcuts are window listeners: they see every keydown in the
 * app while a table tab is open — including the ones typed into a modal on
 * top of it. Ctrl+F in the Edit cell modal opened the grid's find bar BEHIND
 * the modal (whose mount then stole focus out of the modal); Alt+Shift+F
 * formatted the SQL behind it.
 *
 * `shouldGridHandleKey(e)` is false while a shared Modal is open or when the
 * event comes from inside one (a modal drawn outside the shared component
 * still carries `.modal-content`).
 */
import { isModalOpen } from '../ui/Modal';

export function shouldGridHandleKey(e) {
  if (isModalOpen()) return false;
  // The grid's right-click menu owns the arrows / Enter while it is open.
  if (typeof document !== 'undefined' && document.querySelector('[data-dbm-context-menu]')) return false;
  const target = e && e.target;
  if (target && typeof target.closest === 'function' && target.closest('.modal-content')) return false;
  return true;
}
